import React from 'react';
import { Box, Typography } from '@mui/material';
import logoLone from '../assets/logolone.png';

export default function StorySection() {
  return (
    <Box
      sx={{
        width: '100vw',
        maxWidth: '100vw',
        boxSizing: 'border-box',
        bgcolor: '#0a716e',
        color: '#fff',
        py: { xs: 6, md: 10 },
        px: { xs: 0, sm: 1, md: 0 },
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        border: { xs: '1px solid #164c4a', sm: '2px solid #164c4a' },
        overflowX: 'hidden',
      }}
    >
      {/* Consistent inner content wrapper matching header horizontal padding */}
      <Box sx={{
        width: '100%',
        maxWidth: '1900px',
        mx: 'auto',
        px: { xs: 2.5, sm: 3, md: 3, lg: 15 },
        boxSizing: 'border-box'
      }}>
      <Box
        component="img"
        src={logoLone}
        alt="Ixoria Logo"
        sx={{
          width: 'auto',
          height: { xs: 80, sm: 110, md: 170 },
          mb: { xs: 2, md: 4 },
          // Start at same left padding as header; no additional left margins
          display: 'block',
        }}
      />
      <Typography
        variant="h3"
        sx={{
          fontWeight: 500,
          fontSize: { xs: 22, sm: 26, md: 34, lg: 50 },
          mb: { xs: 2, md: 3, lg: 5 },
          // Align to the same starting point as the logo/image
          textAlign: 'left',
          fontFamily: 'Neue Haas Grotesk Display Pro, Inter, Roboto, Arial, sans-serif',
        }}
      >
        The Story<Box component="span" sx={{ fontStyle: 'italic', fontWeight: 100, display: 'inline-block', px: '0.25em' }}>of</Box> Ixoria Herbal Project
      </Typography>
      <Box sx={{ width: '100%', mx: 0, px: 0, boxSizing: 'border-box', textAlign: 'justify' }}>
        <Typography
          sx={{
            fontSize: { xs: 15, sm: 16, md: 20, lg: 38 },
            wordBreak: 'break-word',
            fontWeight: 300,
            lineHeight: { xs: 1.45, sm: 1.3, md: 1.2 },
            mb: 2.5,
            fontFamily: 'Neue Haas Grotesk Display Pro, Inter, Roboto, Arial, sans-serif',
          }}
        >
          Ixoria started in <Box component="span" sx={{ fontWeight: 500 }}>2022</Box> with a clear intention to take <Box component="span" sx={{ fontWeight: 500 }}>well-researched herbs</Box> and transform them into high-performance <Box component="span" sx={{ fontWeight: 500 }}>skincare solutions</Box>. Instead of creating a large range of products, our focus was on depth: <Box component="span" sx={{ fontWeight: 500 }}>crafting one effective formula and refining it to its best</Box>.
        </Typography>
        <Typography
          sx={{
            fontSize: { xs: 15, sm: 16, md: 20, lg: 38 },
            wordBreak: 'break-word',
            fontWeight: 300,
            lineHeight: { xs: 1.45, sm: 1.3, md: 1.2 },
            mb: 2.5,
            fontFamily: 'Neue Haas Grotesk Display Pro, Inter, Roboto, Arial, sans-serif',
          }}
        >
          <Box component="span" sx={{ fontWeight: 500 }}>We began with a simple face pack.</Box> As it gained popularity, we naturally started offering personalised advice on <Box component="span" sx={{ fontWeight: 500 }}>diet, lifestyle, and oral medicine support</Box> which brought even better results for our users. That experience shaped our core belief: <Box component="span" sx={{ fontWeight: 500 }}>real skincare is holistic.</Box>
        </Typography>
        <Typography 
          sx={{
            fontSize: { xs: 15, sm: 16, md: 20, lg: 38 },
            wordBreak: 'break-word',
            fontWeight: 300,
            lineHeight: { xs: 1.45, sm: 1.3, md: 1.2 },
            mb: 2.5,
            fontFamily: 'Neue Haas Grotesk Display Pro, Inter, Roboto, Arial, sans-serif',
          }}
        >
          <Box component="span" sx={{ fontWeight: 500 }}>
            Rather than offering more products, we chose to offer more value.
          </Box> A single, powerful formulation—backed by everything else your skin truly needs. After continuous refinement and learning from real-world results, our original face pack evolved into a smooth, ready-to-use face mask.
        </Typography>
        <Typography
          sx={{
            fontSize: { xs: 15, sm: 16, md: 20, lg: 38 },
            wordBreak: 'break-word',
            fontWeight: 300,
            lineHeight: { xs: 1.45, sm: 1.3, md: 1.2 },
            fontFamily: 'Neue Haas Grotesk Display Pro, Inter, Roboto, Arial, sans-serif',
          }}
        >
          This is where our story continues—with intention, care, and authenticity.
        </Typography>
      </Box>
      </Box>
    </Box>
  );
}
